import script from "./OrderDetailsView.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderDetailsView.vue?vue&type=script&setup=true&lang=js"

import "./OrderDetailsView.vue?vue&type=style&index=0&id=53ccc118&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53ccc118"]])

export default __exports__